import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';

import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AuthService } from '../../../services/auth.service';
import { ReportService } from '../../../services/report.service';
import { Utilities } from '../../../services/utilities';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { AccountService } from '../../../services/account.service';
import { ODPProjectWorkflowViewModel } from '../../../models/odpprojectworkflow/odpProjectWorkflow.model';


@Component({
  selector: 'app-report-abstract-values',
  templateUrl: './report-abstract-values.component.html',
  styleUrls: ['./report-abstract-values.component.css'],
  imports: [ 
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule
  ]
})
export class ReportAbstractValuesComponent implements OnInit {
  years: string[];
  activeProject: ODPProjectWorkflowViewModel;
  activeProjectTitle: string;
  getFilename = (year: string) => `AbstractValues ${year} (${this.activeProjectTitle}) ${this.reportService.FormattedDateNoSeconds}.xlsx`;

  constructor(
    private accountService: AccountService,
    private alertService: AlertService,
    private authService: AuthService,
    private reportService: ReportService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.authService.isSessionExpired) {
      return this.router.navigateByUrl('/account/login');
    }
    this.activeProject = this.accountService.GetActiveProject();
    this.activeProjectTitle = this.activeProject.projectTitle;
    this.loadData();
  }

  loadData() {
    this.alertService.startLoadingMessage();

    this.reportService.getAbstractFYs(this.activeProject.odpProjectWorkflowId).subscribe({
      next: years => {
        this.alertService.stopLoadingMessage();
        this.years = years;
      },
      error: (error) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage(
          'Server error',
          `Unable to retrieve list of years for the report.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error,
          error);
    }});
  }

  onSubmit(year: string) {
    this.alertService.startLoadingMessage();

    var odpProjectWorkflowId = this.activeProject.odpProjectWorkflowId;

    this.reportService.getAbstractValuesReport(odpProjectWorkflowId, year === 'All' ? null : year).subscribe({
      next: (data: ArrayBuffer) => {
        this.alertService.stopLoadingMessage();

        if (data) {
          const blob = new Blob([data], {type: this.reportService.ReportContentType});
          saveAs(blob, this.getFilename(year));
        } else {
          this.alertService.showStickyMessage(
            'Empty Result',
            `Abstract values report returned an empty result for year ${year}.`,
            MessageSeverity.warn);
        }
      },
      error: (error) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage(
          'Server error',
          `An error ocurred while building the abstract values report.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error,
          error);
    }});
  }
}
